import { contact } from "./data";

// The WhatsApp channel: turning an already-composed message into a deep link.
// What goes *into* those messages now lives in enquiry.js, next to the email
// and sheet payloads, so all three stay in step.

// Build a wa.me deep link that opens WhatsApp with a prefilled message.
export function waLink(message) {
  const num = contact.whatsapp.replace(/\D/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(message)}`;
}

// Open WhatsApp (new tab / app) with the given prefilled message.
export function openWhatsApp(message) {
  window.open(waLink(message), "_blank", "noopener,noreferrer");
}

// The plain "tap the number" case — a phone anchor with no enquiry context of
// its own (nav bars, footers, error text). Same wa.me destination as the
// enquiry flows, just with a generic opener message instead of a specific
// requirement.
export const phoneWaHref = waLink(
  "Hi Sigma Enterprises — I'd like to enquire about paper and board."
);
